export * from "plur-count";
export { default } from "plur-count";
